/**
 * 模块简介:演示案例,取名demo.js
 * 作用：演示vuex用法
 */

// 0.先在【根模块】中注册该【子模块】,也就是在store文件夹的index.js中:先import demo from './modules/demo',再在【根空间】子模块注册区modules中注册这个demo子模块

// 1.引入本模块必要的外部api文件(如无必要:此步可以省略)
// import { xxx } from 'xxx'

// 2.配置vuex的必要属性,一共5个,本例演示常用的3个
const state = {
  // 假设在demo模块的state中,有三个不同类型的自定义变量
  name: 'zhangsan',
  count: 0,
  flag: true
}

// 同步方法区(一般用来给state赋值)
const mutations = {
  // 假设在demo模块的mutations中,有一个自定义方法,用于改变state中的值
  // 备注:mutations中的【所有方法】,如果有入参,第一个参数永远为state,它是默认参数,第二个参数payload对象为【可选参数】,用来封装传入的自定义参数
  // 实际调用时不需要传state,因为它是默认传入的,如:this.$store.commit('changeState', {name:'张三',addNum:2})
  changeState(state, payload) {
    state.count += payload.addNum
    state.name = '张三'
    state.flag = !state.flag
  }
}

// 异步方法区(一般会调用外部api去远程请求后端数据)
const actions = {
  // 假设在demo模块的actions中,有一个自定义方法,用于异步调用mutations中的方法
  // 备注:actions中的【所有方法】,如果有入参,第一个参数永远为context
  invoke(context) {
    context.commit('changeState', { addNum: 10 }) // 调用mutations中的changeState方法处理逻辑
  },
  // 使用ES2015的参数解构后的简化写法如下,至于什么是【参数解构】，请看官网介绍:https://github.com/lukehoban/es6features#destructuring
  invokeSimple({ commit }) {
    commit('changeState', { addNum: 10 })
  }
}

// 4.结尾export
export default {
  namespaced: true, // true表示声明为【带命名空间】的模块,这样该模块下的state,mutations等属性中定义的变量属于【子命名空间】下的局部变量,不会与其他【子命名空间】下的变量冲突;不写namespaced:true,则本模块下的state
  state,
  mutations,
  actions
}

// 结尾语
// 外部vue组件中怎么使用store的各个属性? 以demo.js这个store模块为例,我这里简单概括下,一般这些属性都用在vue组件的计算属性或方法中
// this.$store表示【根state】，已注册在main.js中
//   --获取demo模块中属性state中的name变量：this.$store.state.demo.name
//   --获取demo模块中计算属性getter:this.$store.getters['demo/doubleCount']
//   --调用demo模块中mutations方法:this.$store.commit('demo/increment',payload)
//   --调用demo模块中actions方法:this.$store.dispatch('demo/increment')
